import React, {useCallback} from 'react';
import b_ from 'b_';
import Select from 'react-select';
import I18N from 'assets/i18n/brandlift-project';

import history from 'client/common/utils/history';
import {setCurrentOrg, useCurrentOrg, useOrgsList} from 'client/common/hooks/orgs';

import './header2.css';

const i18nSelector = I18N.common.orgSelector;
const b = b_.with('header2');

export function OrgSelector() {
    const handleOrgChange = useCallback((orgId: number) => {
        setCurrentOrg(orgId);

        const searchParams = new URLSearchParams(location.search);

        if (orgId > 0) {
            searchParams.set('org', String(orgId));
        } else {
            searchParams.delete('org');
        }

        history.push({search: searchParams.toString()});
    }, []);

    const {isSuccess, data} = useOrgsList();

    const orgOptions =
        (data?.orgs ?? [])
            .map(org => {
                return {value: org.id, label: org.name};
            })
            .concat({value: 0, label: i18nSelector.ownSurveys}) ?? [];

    const orgId = useCurrentOrg();
    const currentOrgOption = orgOptions.find(option => option.value === (orgId ?? 0));

    return isSuccess && orgOptions.length > 1 ? (
        <>
            <Select
                onChange={e => handleOrgChange(e!.value)}
                options={orgOptions}
                value={currentOrgOption}
                className={b('org-selector')}
                size='m'
                disabled={false}
                view='dl-clear'
            />
        </>
    ) : null;
}
